import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import { BrowserRouter } from "react-router-dom";

import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// 🔥 FIX: Override typography for Styled Components engine
const theme = createTheme({
  palette: {
    primary: {
      main: "#000000",       // BLACK
      contrastText: "#ffffff",
    },
  },
  typography: {
    fontFamily: "Poppins, sans-serif",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          backgroundColor: "#000000",
          color: "#ffffff",
          "&:hover": {
            backgroundColor: "#222222",
          },
        },
        outlinedPrimary: {
          borderColor: "#000000",
          color: "#000000",
          "&:hover": {
            borderColor: "#222222",
            backgroundColor: "rgba(0,0,0,0.08)",
          },
        },
        textPrimary: {
          color: "#000000",
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        "*": {
          fontFamily: "Poppins !important",
        },
        body: {
          fontFamily: "Poppins, sans-serif !important",
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ThemeProvider>
);
